import Api from "@/service/api";
export default class ContactService {
  createContactMessage(message) {
    return Api(false)
      .post("/contact", message)
      .then((res) => res.data);
  }
}
